export default __webpack_public_path__ + "static/media/suv.27bf98c9.png";